import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  data() {
    return {
      datacollection: {
        labels: [
          '7/1/2017',
          '8/1/2017',
          '9/1/2017',
          '10/1/2017',
          '11/1/2017',
          '12/1/2017',
        ],
        datasets: [
          {
            label: 'Real Estate',
            backgroundColor: 'rgba(51, 153, 255, 0.20)',
            borderColor: 'rgba(51, 153, 255, 0.90)',
            data: [
              10.03,
              10.90,
              10.23,
              11.43,
              12.21,
              12.09,
            ],
          },
          {
            label: 'The Market',
            backgroundColor: 'rgba(51, 153, 255, 0.20)',
            borderColor: 'rgba(51, 153, 255, 0.90)',
            data: [
              6.03,
              6.90,
              7.43,
              6.95,
              7.13,
              8.32,
            ],
          },
        ],
      },
    };
  },
  mounted() {
    const vm = this;
    vm.renderChart(vm.datacollection, {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      lineTension: 0,
      tooltips: {
        callbacks: {
          title: tooltipItems => `${tooltipItems[0].xLabel}`,
          // label: tooltipItem => `$${tooltipItem.yLabel.toLocaleString('currency')}`,
          label: tooltipItem => `${Number.parseFloat(tooltipItem.yLabel).toPrecision(3)}%`,
        },
      },
      scales: {
        yAxes: [{
          ticks: {
            callback: value => `${Number.parseFloat(value).toPrecision(3)}%`,
            max: 14.00,
            min: 4.00,
            stepSize: 2,
          },
        }],
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/charts/REvMarket.js